import { render, staticRenderFns } from "./pbnumExample.vue?vue&type=template&id=c83517f8&scoped=true"
import script from "./pbnumExample.vue?vue&type=script&lang=js"
export * from "./pbnumExample.vue?vue&type=script&lang=js"
import style0 from "./pbnumExample.vue?vue&type=style&index=0&id=c83517f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83517f8",
  null
  
)

export default component.exports